import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import useAuthStatus from '../../hooks/authHook';
import { logout } from '../../actions';


import './menudrawer.css';

const MenuDrawer = (props) => {
  const { location: { pathname }, history, doLogout, auth } = props;
  const isLogged = useAuthStatus(auth.token);

  if (!isLogged) {
    return false;
  }

  const urls = [
    { className: 'menu-dashboard', path: '/dashboard', label: 'Dashboard' },
    { className: 'menu-templates', path: '/templates', label: 'Templates' },
    { className: 'menu-instructions', path: '/instructions', label: 'Instructions' },
    { className: 'menu-glossary', path: '/glossary', label: 'Glossary' },
    { className: 'menu-extra-infos', path: '/extra-information', label: 'Extra Information Sources' },
    { div: true },
    { className: 'menu-about-us', path: 'http://uglobally.com/about', label: 'About us', external: true },
  ]

  const links = urls.map((elem, index) => {
    const { path, label, className, div, external } = elem;
    const activeClass = pathname === path ? ' linkActive' : '';

    // link division
    if(div) {
      return (
        <li key={'menu_' + index} className="link-division"></li>
      )
    }

    let ret=<li key={'menu_' + index} className={className + activeClass}><Link to={path} className={"dashboard-menu-item"}>{label}</Link></li>

    if(external) {
      ret=<li key={'menu_' + index} className={className + activeClass}><a target="_blank" href={path} className={"dashboard-menu-item"}>{label}</a></li>
    }

    return ret;
  });

  const onLogout = () => {
    doLogout();
    history.push("/");
  }

  const fullName = auth.firstName + ' ' + auth.lastName;

  return (
    <div id="menudrawer">
      <h2>Menu</h2>
      <div id="profile">
        <div className="profilepic-wraper">
          <img src={auth.profilePicture} alt="Profile" />
        </div>
        <h2>{fullName}</h2>
        <p className="sign-out" onClick={onLogout}>Sign out</p>
      </div>
      <nav>
        <ul>{links}</ul>
      </nav>
    </div>
  )
}

const mapState2Props = (state) => ({
  auth: state.auth
})

const mapDispatch2Props = (dispatch) => {
  return {
    doLogout: () => dispatch(logout())
  }
}

export default connect(mapState2Props, mapDispatch2Props)(withRouter(MenuDrawer))